export default __webpack_public_path__ + "static/media/screenshot2_sm.22021f57.jpg";